import { render, staticRenderFns } from "./Create_User.vue?vue&type=template&id=530fb197&scoped=true&"
import script from "./Create_User.vue?vue&type=script&lang=js&"
export * from "./Create_User.vue?vue&type=script&lang=js&"
import style0 from "./Create_User.vue?vue&type=style&index=0&id=530fb197&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530fb197",
  null
  
)

export default component.exports